/** Question types whose label renders as the step's visible heading. */
const HEADING_QUESTION_TYPES: ReadonlySet<string> = new Set([
  "leadFlowCareForQuestion",
  "leadFlowCareTypeQuestion",
  "leadFlowPostalCodeQuestion",
  "leadFlowUrgencyQuestion",
]);

export { HEADING_QUESTION_TYPES };
